import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SecoesDeSplitter1, VerticalBuildingType } from '../../state/network-parameters.model.generated';

@Component({
  selector: 'app-vertical-balanced-form',
  templateUrl: './vertical-balanced-form.component.html',
  styleUrls: ['./vertical-balanced-form.component.scss']
})
export class VerticalBalancedFormComponent implements OnInit {

  @Input()
  type: VerticalBuildingType;

  @Input()
  form: FormGroup;

  private privateAccessPerPon: number;
  @Input()
  set accessPerPon(value: number) {
    this.privateAccessPerPon = value;
    if (this.form.controls.verticalSections) {
      this.validateSections();
    }
  }
  get accessPerPon(): number {
    return this.privateAccessPerPon;
  }

  sections = ['', null, null];
  sectionsGroup = 3;
  sectionsError = false;

  readonly allowedSplitterValues = ALLOWED_SPLITTER_VALUES;

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.loadSections();
  }

  sectionsChange(sections: string[]) {
    this.type.configuration.splitter_sections =
      sections
        .filter(s => s !== null && s !== '')
        .map((s, index, all) => {
          return {
            splitter: Number(s.replace('1x', '')),
            can_use_internally: index >= 3 - this.sectionsGroup
          };
        }) as SecoesDeSplitter1;

    this.validateSections();
  }

  sectionsGroupChange(group: number) {
    this.type.configuration.splitter_sections
      .forEach((section, index, all) => {
        section.can_use_internally = index >= 3 - group;
      });
  }

  private createForm(): void {
    this.form.addControl('verticalSections', this.fb.control(true, Validators.requiredTrue));
  }

  private loadSections() {
    let reachedGroup = false;
    this.type.configuration.splitter_sections
      .forEach((section, i, all) => {
        this.sections[i] = `1x${section.splitter}`;
        if (this.sectionsGroup === 3 && section.can_use_internally && !reachedGroup) {
          this.sectionsGroup -= i;
          reachedGroup = true;
        }
      });
  }

  private validateSections(): void {
    const { splitter_sections } = this.type.configuration;

    let multiplication = 1;

    if (splitter_sections.length) {
      multiplication = splitter_sections.reduce((value, current) => {
        if (!ALLOWED_SPLITTER_VALUES.map(this.splitterToNumber).includes(current.splitter)) {
          return 0;
        }
        if (current.splitter) {
          return value * current.splitter;
        }
        return value;
      }, multiplication);
    }

    if (this.accessPerPon > 0) {
      this.sectionsError = multiplication !== Number(this.accessPerPon);
    } else {
      this.sectionsError = false;
    }

    this.form.get('verticalSections').setValue(!this.sectionsError);
  }

  private splitterToNumber(splitter: string): number {
    const value = splitter.replace('1x', '');
    return Number(value);
  }
}

const ALLOWED_SPLITTER_VALUES = ['1x0', '1x2', '1x4', '1x8', '1x16', '1x32'];
